import { useEffect, useState } from 'react';
import Form from 'react-bootstrap/esm/Form';
import Table from 'react-bootstrap/esm/Table';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../app/store';
import { ValueType } from '../../app/types';
import MeasurementInputTypeDisplay from '../inputs/MeasurementInputTypeDisplay';
import ValueResponseDisplay from '../inputs/ValueResponseDisplay';
import ValueTypeDisplay from '../inputs/ValueTypeDisplay';
import LoadingIndicator from '../loading/LoadingIndicator';
import { useAuth } from '../signin/auth';
import { formatEntriesForTable, FormattedTableEntry } from '../timeseries/timeseriesSlice';
import styles from './DisplayMeasurementDetail.module.css';
import { getMeasurement, selectEntries, selectMeasurement } from './measurementSlice';

interface DisplayMeasurementDetailProps {
  measurementID: string
}

function DisplayMeasurementDetail(props: DisplayMeasurementDetailProps) {
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const { measurementID } = props;
  const measurement = useSelector((state: RootState) => selectMeasurement(state));
  // const entries = useSelector((state: RootState) => selectEntriesByMeasurementID(state, measurementID));
  const measurementStatus = useSelector((state: RootState) => state.measurement.status)
  const measurementError = useSelector((state: RootState) => state.measurement.error)
  const entries = useSelector((state: RootState) => selectEntries(state));
  const [tableRows, setTableRows] = useState<Array<FormattedTableEntry>>([]);

  useEffect(() => {
    if (auth.authToken) {
      dispatch(getMeasurement({
        authToken: auth.authToken,
        measurementID: measurementID,
        includeEntries: true,
      }));
    }
  }, [dispatch, auth.authToken, measurementID]);

  useEffect(() => {
    if (entries.series.length > 0) {
      setTableRows(formatEntriesForTable(entries));
    } else if (tableRows.length !== 0) {
      setTableRows([]);
    }
  }, [setTableRows, entries, tableRows.length]);

  return (
    <>
      {measurementStatus === 'loading' && <LoadingIndicator />}
      {measurementError && <div>{measurementError}</div>}
      {measurement && (
        <Table striped>
          <tbody>
            <tr>
              <th>ID</th>
              <td><code>{measurement.id}</code></td>
            </tr>
            <tr>
              <th>Name</th>
              <td>{measurement.name}</td>
            </tr>
            <tr>
              <th>Active</th>
              <td>
                <Form.Check type="checkbox" checked={measurement.active} disabled={true} />
              </td>
            </tr>
            <tr>
              <th>Input Type</th>
              <td>
                <MeasurementInputTypeDisplay value={measurement.inputType} />
              </td>
            </tr>
            <tr>
              <th>Type</th>
              <td>
                <ValueTypeDisplay value={measurement.type} />
              </td>
            </tr>
            {(measurement.type === ValueType.Integer) && (
              <tr>
                <th>Valid Integers</th>
                <td>{measurement.validIntegers}</td>
              </tr>
            )}
            <tr>
              <th>Order</th>
              <td>{measurement.order}</td>
            </tr>
            <tr>
              <th>Prompt</th>
              <td>{measurement.prompt}</td>
            </tr>
          </tbody>
        </Table>
      )}
      {entries && (
        <>
          <h2>Entries</h2>
          <Table striped bordered size="sm" hover className={`mt-3 ${styles.entries}`}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              {tableRows.map((row) => {
                return (<tr key={row.key}>
                  <td>{row.date.toLocaleDateString()}</td>
                  <td><ValueResponseDisplay value={row.value} /></td>
                </tr>);
              })}
            </tbody>
          </Table>
        </>
      )}
    </>
  );
}

export default DisplayMeasurementDetail;